@if (current(); as push) {
<!-- En haut, sous l'encoche ; au-dessus de tout sauf des feuilles système. -->
<div
  class="fixed inset-x-2 z-[1000000] rounded-card bg-vw-surface p-3 shadow-float"
  [style.top.px]="safeTop() + 8"
  role="alert"
  (touchstart)="onTouchStart($event)"
  (touchend)="onTouchEnd($event)"
>
  <div class="flex items-start gap-3">
    <span
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl"
      [class]="severity === 'urgent' ? 'bg-vw-danger text-vw-on-color' : 'bg-vw-surface-tint text-vw-primary-ink'"
      aria-hidden="true"
    >
      <!-- Pictogramme de la catégorie de l'alerte (data.category), la cloche à défaut -->
      <vw-alert-category-icon class="h-5 w-5" [category]="push.data?.['category']" />
    </span>
    <div class="min-w-0 flex-1">
      @if (severity) {
      <span
        class="mb-1 inline-block rounded-pill px-2 py-0.5 text-caption font-semibold"
        [class]="severity === 'urgent' ? 'bg-vw-danger text-vw-on-color' : 'bg-vw-warn-bg text-vw-warn-ink'"
      >
        {{ (severity === "urgent" ? "push.banner.urgent" : "push.banner.watch") | translate }}
      </span>
      }
      @if (push.title) {
      <p class="line-clamp-2 text-body font-semibold text-vw-ink">{{ push.title }}</p>
      }
      @if (push.body) {
      <p class="line-clamp-2 text-body-s text-vw-muted">{{ push.body }}</p>
      }
    </div>
    <button
      type="button"
      class="min-h-target shrink-0 rounded-pill border border-vw-primary px-4 text-body-s font-semibold text-vw-primary-ink"
      (click)="view()"
    >
      {{ "push.banner.view" | translate }}
    </button>
  </div>
</div>
}
